import React, { useEffect } from "react";
import { FONTS } from "../constants/Fonts";
import { IMAGE_CONSTANTS } from "../constants/ImageConstans";
import GradientText from "../components/base/GradientText";

const ClaimingUserModal = ({
    open,
    setClaimingTypeRaiseByUser,
    dissmissClaimingUserModal,
    claimingUsers = [
        {
            "avatar": "",
            "claimType": "early_five",
            "displayClaimType": "EARLY FIVE",
            "entityIdClaim": [
                "6947f967c33a7144f4eb07cb",
                "6947f968c33a7144f4eb07f3",
                "6947f969c33a7144f4eb080b",
                "6947f969c33a7144f4eb080d"
            ],
            "gameId": "6960d4fe5e26a26fa465675d",
            "index": 36,
            "name": "QuizWarrior",
            "ticketId": "6960d4fe5e26a26fa465676f",
            "userId": "23470ce7e18e61e220bb2d7a",
            "isClaimSuccess": true,
            "claimResults": {
                "userId": "23470ce7e18e61e220bb2d7a",
                "gameId": "6960d4fe5e26a26fa465675d",
                "claimType": "early_five",
                "ticketId": "6960d4fe5e26a26fa465676f",
                "status": "claimed",
                "name": "QuizWarrior",
                "avatar": "",
                "displayClaimType": "EARLY FIVE",
                "matchedEntity": [
                    "6947f967c33a7144f4eb07cb",
                    "6947f968c33a7144f4eb07f3",
                    "6947f969c33a7144f4eb080b",
                    "6947f969c33a7144f4eb080d"
                ],
                "notMatchedEntity": []
            }
        }
    ]
}) => {

    const isClaimWinner = (user = {}) => {
        const status = String(
            user?.status || user?.claimResults?.status || ''
        ).toLowerCase();
        return (
            user?.isClaimSuccess === true ||
            status === 'claimed' ||
            status === 'success' ||
            status === 'valid' ||
            status === 'winner' ||
            status === 'approved'
        );
    };

    // Split users into successful and unsuccessful
    const successfulUsers = claimingUsers.filter(isClaimWinner);

    useEffect(() => {
        if (open) {
            console.log('ClaimingUserModal opened with claimingUsers : ', claimingUsers);
            console.log('ClaimingUserModal opened with successfulUsers : ', successfulUsers);
            const timer = setTimeout(() => {
                setClaimingTypeRaiseByUser(successfulUsers);
                dissmissClaimingUserModal(successfulUsers);
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [open, claimingUsers]);

    if (!open) return null;

    //console.log('ClaimingUserModal - claimingUsers:', claimingUsers);

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>


                {/* Header */}
                <div style={{ flex: 1, display: 'flex', textAlign: "center", marginBottom: 10, flexDirection: 'column', height: '150px', }}>
                    <GradientText
                        text={`Results`}
                        fontSize="36px"
                        fontWeight={600}
                        textColor='#FFFFFF'
                        fontFamily={FONTS.MONTSERRAT_MEDIUM} />
                    <GradientText
                        text={`${claimingUsers?.length} Claims`}
                        fontSize="20px"
                        fontWeight={600}
                        textColor='#FFFFFFCC'
                        fontFamily={FONTS.MONTSERRAT_MEDIUM} />
                </div>

                {/* Claims List */}
                <div style={styles.listContainer}>
                    {claimingUsers?.map((user, index) => {
                        const isWinner = isClaimWinner(user);

                        return (
                            <div key={index} style={styles.userRow}>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 20,
                                        flex: 1
                                    }}
                                >
                                    <div style={{ flex: 0, display: 'flex', width: '100%', flexDirection: 'column', gap: 0, justifyContent: 'start', alignItems: "start", textAlign: 'left' }}>
                                        <img
                                            src={user?.avatar}
                                            alt={user?.name}
                                            style={styles.avatar}
                                        />
                                    </div>
                                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0, justifyContent: 'start', alignItems: "start", textAlign: 'center', marginLeft: 0 }}>
                                        <GradientText
                                            text={user?.name}
                                            fontSize="18px"
                                            fontWeight={600}
                                            textColor='#FFFFFFB2'
                                            fontFamily={FONTS.MONTSERRAT_MEDIUM} />
                                        <GradientText
                                            text={`#${user?.displayClaimType}`}
                                            fontSize="24px"
                                            fontWeight={600}
                                            textColor='#5FE72E'
                                            fontFamily={FONTS.MONTSERRAT_MEDIUM} />
                                    </div>
                                </div>
                                <div style={styles.statusContainer}>
                                    <img
                                        src={
                                            isWinner
                                                ? IMAGE_CONSTANTS.V2_RAP_HOUSIE_CLAIM_WINNER
                                                : IMAGE_CONSTANTS.V2_RAP_HOUSIE_CLAIM_BOGUS
                                        }
                                        alt="status"
                                        style={styles.statusIcon}
                                    />
                                    <p style={styles.text_claim_status}>
                                        {isWinner ? "WINNER" : "Bogus"}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

const styles = {
    overlay: {
        position: "fixed",
        inset: 0,
        background: `url(${IMAGE_CONSTANTS.BLUR_BACKGROUND_2}) center center / cover no-repeat`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
    },

    modal: {
        textAlign: "center",
        userSelect: "none",
        height: "600px",
        width: "600px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "start",
        backgroundColor: "#121212",
        borderRadius: "20px",
        padding: "20px",
    },
    listContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "0px",
        width: "100%",
        height: "100%",
        marginTop: "10px",
        justifyContent: 'start',
        alignItems: "start",
        overflowY: 'auto',
        scrollbarWidth: 'none', /* Firefox */
        msOverflowStyle: 'none', /* IE and Edge */
    },
    userRow: {
        width: "100%",
        height: 'auto',
        display: "flex",
        alignItems: "center",
        gap: "20px",
        padding: "10px 0",
        justifyContent: "space-between",
    },

    statusContainer: {
        flex: 0,
        width: "auto",
        textAlign: "center",
    },
    statusIcon: {
        width: "30px",
        height: "26px",
    },
    avatar: {
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        objectFit: "cover",
        borderRadius: '50%',
        borderColor: '#FFFFFF33',
        borderWidth: 1,
        borderStyle: 'solid',
    },
    text_title: {
        fontSize: "36px",
        fontWeight: 600,
        color: '#FFFFFF',
        fontFamily: FONTS.MONTSERRAT_MEDIUM,
    },
    text_claim: {
        fontSize: "20px",
        fontWeight: 600,
        color: '#FFFFFFCC',
        fontFamily: FONTS.MONTSERRAT_MEDIUM,
    },
    text_name: {
        fontSize: "18px",
        fontWeight: 600,
        color: '#FFFFFFB2',
        fontFamily: FONTS.MONTSERRAT_MEDIUM,
    },
    text_claim_type: {
        fontSize: "28px",
        fontWeight: 600,
        color: '#5FE72E',
        fontFamily: FONTS.MONTSERRAT_MEDIUM,
    },
    text_claim_status: {
        fontSize: "11px",
        fontWeight: 600,
        color: '#FFFFFF',
        fontFamily: FONTS.MONTSERRAT_MEDIUM,
    },
};

export default ClaimingUserModal;
